import styled, { css } from 'styled-components';

import { colors, cssBreakpoints, gutterWidth, transition } from 'theme/theme';

const CHART_HEIGHT = 240;

export const MainChartWrapper = styled.div`
  margin-top: 80px;
  margin-bottom: ${gutterWidth * 1.5}px;
  position: relative;
`;

export const TooltipContainer = styled.div`
  text-align: center;
`;

export const ChartDataContainer = styled.div<{
  $loading: boolean;
  $initialized: boolean;
}>`
  display: flex;
  align-items: flex-end;
  height: ${CHART_HEIGHT}px;
  pointer-events: ${({ $initialized, $loading }) =>
    ($loading || !$initialized) && 'none'};
  position: relative;
  transition: all ${transition};
  border-bottom: 4px solid ${colors.brandYellow};
  z-index: 102;
`;

export const MainChartContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
`;

export const ChartDataWrapper = styled.div<{
  chartWidth: number;
  $xGridInterval: number;
  $yGridInterval: number;
  $showXGridLines?: boolean;
  $showYGridLines?: boolean;
}>`
  position: absolute;
  display: flex;
  height: 100%;
  margin-left: calc(50% + 4px);
  width: calc(100% - 80px);
  top: 0;
  transform: translateX(-50%);

  ${(props) =>
    props.$showYGridLines
      ? css`
          background-image: linear-gradient(
              to right,
              ${colors.white} 5px,
              transparent 1px
            ),
            linear-gradient(${colors.elementGrey} 1px, transparent 1px);
          background-size: 8px ${props.$yGridInterval}px;
        `
      : undefined}

  ${(props) =>
    props.$showXGridLines
      ? css`
          background-image: linear-gradient(
              to bottom,
              ${colors.white} 5px,
              transparent 1px
            ),
            linear-gradient(
              to right,
              ${colors.elementGrey} 1px,
              transparent 1px
            );
          background-size: ${props.$xGridInterval}px 8px;
        `
      : undefined};
`;

export const BarContainer = styled.div<{ $bucketCount: number }>`
  position: relative;
  width: 100%;
`;

export const HorizontalAxisWrapper = styled.div`
  margin: 0 auto;
  width: calc(100% - 80px);

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    width: calc(100% - 80px);
  }
`;
